import { tasks as API } from '../../api'
import Task from '../models/Task'

import { store } from 'w3box-vue-api'
const { state, getters, actions, mutations } = store

export default {
  namespaced: false,
  state: {
    ...state(),
    autoload: false,
  },
  getters: {
    ...getters(),
    newItem: state => data => new Task(data),
  },
  actions: actions(API),
  mutations: mutations(),
}